module.exports = __webpack_public_path__ + "img/COLV1.ec007b97.webp";